import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import isString from 'lodash/isString';
import Tooltip from '../../tooltip';
import tableContext from '../TableContext';
import ColumnFilter from './ColumnFilter';
/**
 * 获取配置区域 DOM Item
 *
 * @param setting 配置项
 * @param prefixCls
 */
function getSettingItem(setting, prefixCls) {
    if (isString(setting) && setting === 'columnFilter') {
        return React.createElement(ColumnFilter, { prefixCls: prefixCls });
    }
    if (React.isValidElement(setting)) {
        return setting;
    }
    if (setting) {
        const settingConfig = setting;
        const { icon, tooltip, onClick, key } = settingConfig;
        if (icon && tooltip) {
            return (React.createElement(Tooltip, { title: tooltip },
                React.createElement("span", { key: key, onClick: () => {
                        if (onClick) {
                            onClick(key);
                        }
                    } }, icon)));
        }
        return icon;
    }
    return null;
}
const ToolBar = ({ header, hideToolbar, className, style, buttons = [], settings = [], }) => {
    const { tableStore: { prefixCls } } = useContext(tableContext);
    const toolbarPrefixCls = `${prefixCls}-toolbar`;
    const buttonsDom = useMemo(() => {
        if (!Array.isArray(buttons)) {
            return buttons;
        }
        if (buttons.length < 1) {
            return null;
        }
        return (React.createElement("div", { className: `${toolbarPrefixCls}-buttons` }, buttons.map((btn, index) => {
            if (!React.isValidElement(btn)) {
                // eslint-disable-next-line react/no-array-index-key
                return React.createElement(React.Fragment, { key: index }, btn);
            }
            return React.cloneElement(btn, {
                // eslint-disable-next-line react/no-array-index-key
                key: index,
                ...btn.props,
            });
        })));
    }, [buttons]);
    const headerNode = useMemo(() => (React.createElement("div", { className: `${toolbarPrefixCls}-header` }, header)), [header]);
    const settingsDom = useMemo(() => {
        if (!Array.isArray(settings)) {
            return settings;
        }
        if (settings.length < 1) {
            return null;
        }
        return settings.length ? (React.createElement("div", { className: `${toolbarPrefixCls}-setting-items` }, settings.map((setting, index) => {
            const settingItem = getSettingItem(setting, prefixCls);
            return (
            // eslint-disable-next-line react/no-array-index-key
            React.createElement("div", { key: index, className: `${toolbarPrefixCls}-setting-item` }, settingItem));
        }))) : null;
    }, [settings]);
    // 不展示 toolbar
    if (hideToolbar) {
        return null;
    }
    return (React.createElement("div", { style: style, className: classNames(`${toolbarPrefixCls}`, className) },
        React.createElement("div", { className: `${toolbarPrefixCls}-container` },
            headerNode,
            React.createElement("div", { className: `${toolbarPrefixCls}-right` },
                buttonsDom,
                settingsDom))));
};
export default ToolBar;
